export default __webpack_public_path__ + "static/media/66545DAC-1FD6-4A02-9097-527A166715AD_1_105_c.6d4850e5.jpeg";